import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../api/apiclient";
import { AI_AGENT_LIST, FORM_KEYS } from "../../utills/constant";
import { SYSTEM_AI_AGENTS,OCR_FIELDS, CREATE_AI_AGENT } from "../../api/endpoints";

// Async thunk for logging in
export const getSystemAiagents = createAsyncThunk(
  "/api/system_ai_agents/active",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGet(SYSTEM_AI_AGENTS);
      if (response?.data.status === "success") {
        console.log('response?.data',response?.data?.data )
        return response?.data?.data ;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for logging in
export const getOcrFields = createAsyncThunk(
  "/api/system_ai_agent/ocr-field",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${OCR_FIELDS}${slug}/ocr_fields/`);
      if (response?.data.status === "success") {
        console.log('response?.data',response?.data?.data )
        return response?.data?.data ;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

// Async thunk for logging in
export const getProgressLoading = createAsyncThunk(
  "/api/progress",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${CREATE_AI_AGENT}${slug}/progress/`);
      if (response?.data.status === "success") {
        console.log('response?.data',response?.data?.data )
        return response?.data?.data ;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const ActiveSystemAiAgentLists = createSlice({
  name: "ai_agents",
  initialState: {
    activieSystemAiAgentListLoading: false,
    activieSystemAiAgentListError: {},
    activieSystemAiAgentList: [],
    ocrFieldsLoading:false,
    activieSystemAiOcrFields:[],
    ocrFieldsError:{}
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemAiagents.pending, (state) => {
        state.activieSystemAiAgentListLoading = true;
        state.error = null;
      })
      .addCase(getSystemAiagents.fulfilled, (state, action) => {
        state.activieSystemAiAgentListLoading = false;
        state.activieSystemAiAgentList =action.payload.agents?.map((agent, index) => {
          const staticAgent = AI_AGENT_LIST?.data?.agents[index]; // Match by index
          return {
            ...agent,
            ...(staticAgent || {}), // Merge if static data exists for this index
          };
        });
      })
      .addCase(getSystemAiagents.rejected, (state, action) => {
        state.activieSystemAiAgentListLoading = false;
        state.activieSystemAiAgentListError = action.payload;
      })
      .addCase(getOcrFields.pending, (state) => {
        state.ocrFieldsLoading = true;
        state.ocrFieldsError = null;
      })
      .addCase(getOcrFields.fulfilled, (state, action) => {
        state.ocrFieldsLoading = false;
        state.activieSystemAiOcrFields =action.payload
      })
      .addCase(getOcrFields.rejected, (state, action) => {
        state.ocrFieldsLoading = false;
        state.ocrFieldsError = action.payload;
      })
      .addCase(getProgressLoading.pending, (state) => {
        state.progressLoading = true;
        state.progressError = null;
      })
      .addCase(getProgressLoading.fulfilled, (state, action) => {
        state.progressLoading = false;
        state.progressindData =action.payload
      })
      .addCase(getProgressLoading.rejected, (state, action) => {
        state.progressLoading = false;
        state.progressError = action.payload;
      });
      
  },
});

// Exporting the action to save form details
export const { modifyActivieSystemAiOcrFields } = ActiveSystemAiAgentLists.actions;

export default ActiveSystemAiAgentLists.reducer;
